import { defineAppConfig } from '@zto/zpage'

import { exportData, parseFile } from '../utils/xlsx'
import { ZFSUploader, ZFSUploaderOperate, ZFSUploaderKT } from '../utils/upload'

import type { App, AppComponentsConfig, AppContextOptions } from '@zto/zpage'

export default defineAppConfig<AppComponentsConfig>((app: App) => ({
  cmpt: {
    prefixs: ['el-']
  },

  verifyCode: {
    imageProp: 'base64Code'
  },

  fuzzySelect: {
    pageSize: 40
  },

  formItem: {
    input: { maxlength: 100 },
    textarea: { maxlength: 200 }
  },

  table: {
    data: {
      summaryProp: 'sum'
    }
  },

  pagination: {
    layout: 'sizes, prev, pager, next, jumper, ->, total',
    pageSizes: [10, 15, 50, 100],
    pageSize: 15
  },

  xlsx: {
    exportData,
    parseFile
  },

  file: {
    upload: {
      remoteDelete: false,
      storePath: 'kt',
      fn: (file: File, options: AppContextOptions) => {
        // TODO: 如果上传类型如果有uploadType参数，且是kt_store_file，则走ZFSUploaderKT，不是kt_store_file，则走ZFSUploaderOperate，否则还走老的ZFSUploader
        // ZFSUploaderKT（新的获取token，老的上传，新的获取外网地址，为的是兼容之前的老数据（多个filename是用逗号分隔，但新的上传返回的filename里面包含逗号））
        // ZFSUploaderOperate（新的获取token，新的上传，新的获取外网地址，都是新的）
        // 以后只要包含uploadType，除了kt_store_file特殊外，其他都走ZFSUploaderOperate（全新上传链路）
        return options?.uploadType
          ? options?.uploadType === 'kt_store_file'
            ? ZFSUploaderKT.upload(file, options)
            : ZFSUploaderOperate.upload(file, options)
          : ZFSUploader.upload(file, options)
      }
    }
  }
}))
